import { fetchAPI2 } from "../fetchAPI2";
import { simulateApiError } from "../errors";

export const _retrieveInvoiceDownload = async (id: string): Promise<Blob> => {
  // TODO This needs testing

  // await simulateApiError({path: `/invoices/${id}/download`})

  const data = await fetchAPI2<Blob>(`/invoices/${id}/download`);

  return data;
};
